import { CreditCard } from "lucide-react";
import { Container } from "@/components/Container";
import { Label } from "@/components/ui/label";
import { BalanceCard } from "@/components/account/credits/BalanceCard";
import { PurchaseCreditsCard } from "@/components/account/credits/PurchaseCreditsCard";
import { RedeemPromoCard } from "@/components/account/credits/RedeemPromoCard";
import { AgentSelector } from "@/components/AgentSelector";
import { useSelectedPersona } from "@/hooks/use-selected-persona";

export const rpcUrl = import.meta.env.PROD
  ? import.meta.env.VITE_REACT_APP_NEXT_PUBLIC_RPC_URL_PRODUCTION
  : import.meta.env.VITE_REACT_APP_NEXT_PUBLIC_RPC_URL_DEVELOPMENT;

export function CreditManagement() {
  const [selectedPersonaId, setSelectedPersonaId] = useSelectedPersona();

  return (
    <Container className="pt-0">
      <div className="flex flex-col items-center gap-6">
        <div className="w-64 self-center">
          <Label
            className="text-sm font-medium mb-2 block max-w-md"
            htmlFor="agent-selector"
          >
            Select Agent
          </Label>
          <AgentSelector
            id="agent-selector"
            className="w-64"
            value={selectedPersonaId}
            onChange={setSelectedPersonaId}
          />
        </div>

        {selectedPersonaId ? (
          <div className="space-y-6 w-full mx-auto">
            <BalanceCard personaId={selectedPersonaId} />

            <PurchaseCreditsCard personaId={selectedPersonaId} />

            <RedeemPromoCard personaId={selectedPersonaId} />
          </div>
        ) : (
          <div className="text-center py-12 text-muted-foreground">
            <CreditCard className="w-12 h-12 mx-auto mb-4 opacity-50" />
            <h3 className="text-lg font-semibold mb-2">No Agent Selected</h3>
            <p>Select an agent above to manage their credits.</p>
          </div>
        )}
      </div>
    </Container>
  );
}
export default CreditManagement;
